<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{ $t("ROOM_INFOMATION") }}</span>
    </page-header>
    <left-menu />
    <v-card id="room-infomation">
      <v-tabs
        :value="currentTabIndex"
        @change="changeTab"
        background-color="transparent"
        class="main-tab-wrapper main-tab"
      >
        <v-tab
          v-for="tabItem in tabs"
          :tabindex="tabItem.index"
          :key="tabItem.index"
          @click="loadRoute(tabItem.routeName)"
          :disabled="disableTabs.find(x => x.i == tabItem.index).disabled"
        >{{ tabItem.label }}</v-tab>
      </v-tabs>
      <div class="main-content">
        <div class="content">
          <router-view></router-view>
        </div>
      <!-- <span class="tip mt-3" v-if="currentTabIndex == 2">Tips: {{ $t("TIP_MAIN_ROOM_IMAGE") }}.</span> -->
      </div>
    </v-card>
  </v-app>
</template>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { _alert } from "@/_helpers/function.js";
import { Role } from "@/plugins/roles";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu
  },
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("ROOM_INFOMATION"),
          routeName: "roomInformation",
          roles: [
							Role.ROOM_INFORMATION
						]
        },
        {
          index: 1,
          label: this.$t("ROOM_AMENITIES"),
          routeName: "roomAmenities",
          roles: [
							Role.ROOM_AMENITY
						]
        },
        {
          index: 2,
          label: this.$t("ROOM_IMAGE"),
          routeName: "roomImages",
          roles: [
							Role.ROOM_IMAGE
						]
        }
      ],
      data: {},
      newId: null,
      disableTabs: [
        { i: 0, disabled: false },
        { i: 1, disabled: false },
        { i: 2, disabled: false }
      ]
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    this.initialize();
    if (!parseInt(this.$route.params.id)) {
      return false;
    }
  },
  watch: {},
  methods: {
    async initialize() {
      let roomId = parseInt(this.$route.params.id);
      if (!roomId) {
        this.disableTabs = [
          { i: 0, disabled: false },
          { i: 1, disabled: true },
          { i: 2, disabled: true }
        ];
        this.data = {
          image: null,
          defaultPrice: null,
          weekendRate: null,
          maxAdults: 1,
          maxChildern: 0,
          totalRooms: null,
          roomSize: null,
          numberOfExtraBeds: 0,
          i18ns: [
            {
              lang: "vi",
              name: "",
              description: ""
            },
            {
              lang: "en",
              name: "",
              description: ""
            }
          ],
          operationBedTypes: [
            {
              typeId: 1,
              operation: 0,
              quantity: 1
            }
          ],
          amenites: [],
          viewIds: []
        };
        return true;
      }
      await service.getRoomDetail(roomId).then(res => {
        if (res.responseCode == 0) {
          this.data = res.data;
        }
      });
    },
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>
